import get from 'lodash/get'
import {
  AccountSelectionBuilder,
  DataSelectionBuilder,
  FieldMappingBuilder,
  IntegrationFormField,
  IntegrationFormManager,
  IntegrationNameBuilder,
} from '../components'
import { INTEGRATION_TYPE, DATA_TYPE_KEY, DATA_TYPES } from './components/constants'

export function FacebookMarketingOutbound({ assignment }) {
  const integrationFieldsFilter = field =>
    get(field, 'fieldTypes', [])
      .map(row => row.type)
      .includes(assignment.metadata[DATA_TYPE_KEY])

  const assignmentMetaDataType = assignment.metadata[DATA_TYPE_KEY] || DATA_TYPES[0].type
  const integrationNameField = new IntegrationNameBuilder().build()
  const accountSelectionField = new AccountSelectionBuilder()
    .resetOnChange(true)
    .dataType(assignmentMetaDataType)
    .build()
  const dataSelectionField = new DataSelectionBuilder()
    .placement(2)
    .dataOptions(DATA_TYPES)
    .defaultValue(DATA_TYPES[0].type)
    .metadataKey(DATA_TYPE_KEY)
    .resetIntegrationOnChange(true)
    .build()
  const fieldMapping = new FieldMappingBuilder()
    .placement(5)
    .integrationTitle('Facebook Ads Manager')
    .integrationFieldsFilter(integrationFieldsFilter)
    .dataType(assignmentMetaDataType)
    .mappingType('outbound')
    .defaultMappings([
      // Various mappings for different data types
      { claravine: 'Campaign ID', outbound: 'id', type: 'campaigns' },
      { claravine: 'Name', outbound: 'name', type: 'campaigns' },
      { claravine: 'Ad Set ID', outbound: 'id', type: 'ad_sets' },
      { claravine: 'Ads ID', outbound: 'id', type: 'ads' },
      { claravine: 'Ad Creative ID', outbound: 'id', type: 'ad_creatives' },
    ])
    .build()

  const formFields: IntegrationFormField[] = [
    accountSelectionField,
    dataSelectionField,
    fieldMapping,
    integrationNameField,
  ]

  return (
    <div style={{ width: '100%' }}>
      <IntegrationFormManager
        integrationType={INTEGRATION_TYPE}
        integrationAssignment={assignment}
        integrationFields={formFields}
        assignmentMetaDataType={assignmentMetaDataType}
      />
    </div>
  )
}
